import styled, { css } from "styled-components";

export const Container = styled.div<{ isLastCouponInGroup: boolean }>`
    padding: 0 ${(props) => props.theme.spacing.large};
    margin-bottom: calc(${(props) => props.theme.spacing.xSmall} * -1);

    ${(props) =>
        props.isLastCouponInGroup &&
        css`
            margin-bottom: calc(${(props) => props.theme.spacing.xLarge} + ${(props) => props.theme.spacing.xxSmall});
        `}
`;
